import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'

// Views - Pages
// import Page404 from '@/views/pages/Page404'
// import Page500 from '@/views/pages/Page500'
import Login from '@/views/pages/Login'
// import Register from '@/views/pages/Register'

// Victory Garage Views
import Agents from '@/views/agents/Index'
import AgentAdd from '@/views/agents/Add'
import AgentEdit from '@/views/agents/Edit'
import AgentView from '@/views/agents/View'
import Bookings from '@/views/bookings/Index'
import BookingAdd from '@/views/bookings/Add'
import BookingImport from '@/views/bookings/Import'
import BookingEdit from '@/views/bookings/Edit'
import BookingView from '@/views/bookings/View'
import ServiceVouchers from '@/views/serviceVouchers/Index'
import ServiceVoucherEdit from '@/views/serviceVouchers/Edit'
import Invoices from '@/views/invoices/Index'
import InvoiceAdd from '@/views/invoices/Add'
import InvoiceView from '@/views/invoices/View'

import store from '@/store'

Vue.use(Router)

let router = new Router({
  mode: 'history', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/agents',
      name: 'Home',
      component: Full,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'agents',
          redirect: '/agents/list',
          name: 'Agents',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'agent-list',
              component: Agents,
              meta: {
                label: 'List'
              }
            },
            {
              path: 'add',
              name: 'agent-add',
              component: AgentAdd,
              meta: {
                label: 'Add'
              }
            },
            {
              path: ':id',
              props: true,
              name: 'agent-view',
              component: AgentView,
              meta: {
                label: 'View'
              }
            },
            {
              path: ':id/edit',
              props: true,
              name: 'agent-edit',
              component: AgentEdit,
              meta: {
                label: 'Edit'
              }
            },
            {
              path: ':agent_id/bookings',
              props: true,
              name: 'agent-bookings',
              component: Bookings,
              meta: {
                label: 'Bookings'
              }
            }
          ]
        },
        {
          path: 'bookings',
          redirect: '/bookings/list',
          name: 'Bookings',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'booking-list',
              component: Bookings,
              meta: {
                label: 'List'
              }
            },
            {
              path: 'add',
              name: 'booking-add',
              component: BookingAdd,
              meta: {
                label: 'Add'
              }
            },
            {
              path: 'import',
              name: 'booking-import',
              component: BookingImport,
              meta: {
                label: 'Import'
              }
            },
            {
              path: ':id',
              props: true,
              name: 'booking-view',
              component: BookingView,
              meta: {
                label: 'View'
              }
            },
            {
              path: ':id/edit',
              props: true,
              name: 'booking-edit',
              component: BookingEdit,
              meta: {
                label: 'Edit'
              }
            }
          ]
        },
        {
          path: 'service-vouchers',
          redirect: '/service-vouchers/list',
          name: 'Service Vouchers',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'service-voucher-list',
              component: ServiceVouchers,
              meta: {
                label: 'List'
              }
            },
            {
              path: ':id/edit',
              props: true,
              name: 'service-voucher-edit',
              component: ServiceVoucherEdit,
              meta: {
                label: 'Edit'
              }
            }
          ]
        },
        {
          path: 'invoices',
          redirect: '/invoices/list',
          name: 'Invoices',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'invoice-list',
              component: Invoices,
              meta: {
                label: 'List'
              }
            },
            {
              path: 'add',
              name: 'invoice-add',
              component: InvoiceAdd,
              meta: {
                label: 'Add'
              }
            },
            {
              path: ':id',
              props: true,
              name: 'invoice-view',
              component: InvoiceView,
              meta: {
                label: 'View'
              }
            }
          ]
        }
      ]
    },
    {
      path: '/admin',
      redirect: '/admin/login',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login,
          meta: { requiresUnauth: true }
        }
      ]
    }
    // {
    //   path: '/pages',
    //   redirect: '/pages/404',
    //   name: 'Pages',
    //   component: {
    //     render (c) { return c('router-view') }
    //   },
    //   children: [
    //     {
    //       path: '404',
    //       name: 'Page404',
    //       component: Page404
    //     },
    //     {
    //       path: '500',
    //       name: 'Page500',
    //       component: Page500
    //     },
    //     {
    //       path: 'login',
    //       name: 'Login',
    //       component: Login
    //     },
    //     {
    //       path: 'register',
    //       name: 'Register',
    //       component: Register
    //     }
    //   ]
    // }
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('user/validateToken')
  if (store.getters['user/isUserLoggedIn']) {
    if (to.matched.some(record => record.meta.requiresUnauth)) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      next({
        path: '/admin',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js